import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/marketplace/categories';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* run() {
  try {
    const response = yield call(
      axios.get,
      `${config.API_URL}/marketplace/categories`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response.data?.data ?? response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, run);
}
